import React from 'react';
import styles from './Testimonials.module.css';

export default ({ children, source }) => (
  <div className={styles.testimonialEl}>
    <div className={styles.quote}>{children}</div>
    {source && (<div className={styles.source}>{source}</div>)}
  </div>
);
